/* eslint-disable no-restricted-syntax */
import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  Edit,
  useTranslate,
  TabbedForm,
  FormTab,
  useRedirect,
} from 'react-admin';
import canAccess from '../../../utils/canAccess';
import FUNC from '../../../utils/functions';
import UserInfoContainer from '../userInfoContainer';
import UserYusInfoContainer from '../userYusInfoContainer';
import UserCpvInfoContainer from '../userCpvInfoContainer';
import EditToolBar from '../../../components/commons/editToolBar';
import EditActions from '../../../components/commons/editActions';
import TeacherInfoContainer from './teacherInfoContainer';
import repositories from '../../../repositories/user/teachers';
import { VIETNAM_COUNTRY_ID } from '../../../utils/constant';

export default React.memo(() => {
  const { permissions } = useSelector((state: any) => state.app.appState);
  const canPut = canAccess(permissions, FUNC.EDIT_TEACHER);
  const canSearch = canAccess(permissions, FUNC.SEARCH_TEACHERS);
  const canShow = canAccess(permissions, FUNC.SHOW_TEACHER_DETAIL);
  const canUpdateTeacherRole = canAccess(permissions, FUNC.EDIT_ROLE_TEACHER);
  const translate = useTranslate();
  const redirect = useRedirect();
  const transform = (data:any) => {
    const { departments } = data;
    const { faculties } = data;
    for (const element of departments) {
      if (element.positions) {
        element.positions = element.positions.map((x: any) => x.id);
      }
    }
    for (const element of faculties) {
      if (element.facultyPositions) {
        element.facultyPositions = element.facultyPositions.map((x: any) => x.id);
      }
      if (element.majorPositions) {
        element.majorPositions = element.majorPositions.map((x: any) => x.id);
      }
    }
    if (!data.information.isYusMember) {
      data.yusInformation = null;
    }
    if (data.information?.birthPlaceCountryId) {
      if (data.information?.birthPlaceCountryId === VIETNAM_COUNTRY_ID) {
        data.information.birthPlaceProvinceName = '';
      } else {
        data.information.birthPlaceProvinceId = '';
      }
    }
    if (data.information?.permanentAddress?.countryId) {
      if (data.information?.permanentAddress?.countryId === VIETNAM_COUNTRY_ID) {
        data.information.permanentAddress.detailAddress = '';
      } else {
        data.information.permanentAddress.provinceId = '';
        data.information.permanentAddress.districtId = '';
        data.information.permanentAddress.communeId = '';
      }
    }
    if (data.information?.nativeLand?.countryId) {
      if (data.information?.nativeLand?.countryId === VIETNAM_COUNTRY_ID) {
        data.information.nativeLand.detailAddress = '';
      } else {
        data.information.nativeLand.provinceId = '';
        data.information.nativeLand.districtId = '';
        data.information.nativeLand.communeId = '';
      }
    }
    if (data.information?.currentAddress?.countryId) {
      if (data.information?.currentAddress?.countryId === VIETNAM_COUNTRY_ID) {
        data.information.currentAddress.detailAddress = '';
      } else {
        data.information.currentAddress.provinceId = '';
        data.information.currentAddress.districtId = '';
        data.information.currentAddress.communeId = '';
      }
    }
    data.roleIds = data.roleIds.filter((roleId:any) => roleId !== 'GV' && roleId !== 'TG');
    return data;
  };
  const onSuccess = (data:any) => {
    if (data?.information?.avatar?.rawFile) {
      const teacherId = data.id;
      const formData = new FormData();
      formData.append('file', data?.information?.avatar?.rawFile);
      repositories.postAvatarImage(teacherId, formData);
    }
    redirect('/user/teachers');
  };

  return (
    <Edit
      actions={<EditActions isShow={canShow} isList={canSearch} />}
      mutationMode="pessimistic"
      className="mai-form"
      transform={transform}
      mutationOptions={{ onSuccess }}
    >
      <TabbedForm toolbar={<EditToolBar isSave={canPut} />}>
        <FormTab
          sx={{ flexDirection: 'row' }}
          label={translate('resources.user/teachers.fields.teacherInformationLabel')}
        >
          <TeacherInfoContainer isEdit canUpdateTeacherRole={canUpdateTeacherRole} />
        </FormTab>
        <FormTab
          label={translate('resources.user/teachers.fields.userInformationLabel')}
        >
          <UserInfoContainer roleUser="teachers" isEdit />
        </FormTab>
        <FormTab label={translate('resources.user/teachers.fields.yusInformationLabel')}>
          <UserYusInfoContainer isTeachers />
        </FormTab>
        <FormTab label={translate('resources.user/teachers.fields.cpvInformationLabel')}>
          <UserCpvInfoContainer isTeachers />
        </FormTab>
      </TabbedForm>
    </Edit>
  );
});
